<template>
  <div class="sky-hc-search">
    <left-full-nav></left-full-nav>
    <right-content>
      <template>
        <search-box class="sky-hc-search__search-box" v-model="keyword" @search="handleSearch"></search-box>
        <ul class="sky-hc-search__result-nav">
          <li
            class="sky-hc-search__result-nav-item"
            v-for="item in tabList"
            :key="item.categoryId"
            :class="item.categoryId === currentCategory.categoryId ? 'sky-hc-search__result-nav-item--active' : ''"
            @click="handleTabCategory(item)"
          >
            {{ item.categoryName }}（{{ item.articleNumber }}）
          </li>
        </ul>
        <ul class="sky-hc-search__result-list">
          <li
            class="sky-hc-search__result-item"
            v-for="item in resultList"
            :key="item.id"
            @click="handleGoToInnerPage(item)"
          >
            <h2 class="sky-hc-search__result-tit" v-html="item.title"></h2>
            <p class="sky-hc-search__result-con" v-html="item.content"></p>
            <span class="sky-hc-search__result-time">{{
              item.createTime ? date.format(item.createTime, 'yyyy-MM-dd HH:mm:ss') : ''
            }}</span>
            <div class="sky-hc-search__result-split"></div>
          </li>
        </ul>
        <div class="sky-hc-search__pagination">
          <el-pagination
            background
            layout="prev, pager, next"
            v-if="total > 0"
            :total="total"
            :page-size="limit"
            :current-page="page"
            @current-change="handleSizeChange"
          ></el-pagination>
        </div>
        <div class="sky-hc-search__no-data" v-if="total === 0">
          <img
            class="sky-hc-search__no-data-img"
            src="@/assets/images/help/no_search_result.png"
            srcset="@/assets/images/help/no_search_result@2x.png"
          />
          <div class="sky-hc-search__no-data-txt">{{ $t('help.noDataTips') }}</div>
          <div class="sky-hc-search__resolve-box">
            <div class="sky-hc-search__resolve-tit">{{ $t('help.resolveTip') }}</div>
            <div
              class="sky-hc-search__resolve-txt"
              v-html="
                $t('help.resolveMethod1', {
                  link: `<a href='${`/help.html#/help/content?categoryId=${this.downloadId}&categoryName=${this.$t(
                    'help.downCenter'
                  )}&type=${CATEGORY_TYPE.FILE}&tab=1`}' class='sky-hc-search__link' target='help' name='help'>【${$t(
                    'help.downCenter'
                  )}】</a>`
                })
              "
            ></div>
            <div
              class="sky-hc-search__resolve-txt"
              v-html="
                $t('help.resolveMethod2', {
                  link: `<a href='${
                    CONTACT_URL.FEEDBACK_URL
                  }' class='sky-hc-search__link' target='help' name='help'>【${$t('help.feedback')}】</a>`
                })
              "
            ></div>
            <div
              class="sky-hc-search__resolve-txt"
              v-html="
                $t('help.resolveMethod3', {
                  link: `<a href='${
                    CONTACT_URL.ONLINE_CONTACT_URL
                  }' class='sky-hc-search__link' target='help' name='help'>【${$t('help.onlineService')}】</a>`
                })
              "
            ></div>
          </div>
        </div>
      </template>
    </right-content>
  </div>
</template>
<script>
import { Pagination } from 'element-ui'

import date from 'element-ui/lib/utils/date'

import LeftFullNav from '../components/leftFullNav'
import RightContent from '../components/rightContent'
import SearchBox from '../components/searchBox'

import { getSearchList, getIndexCategory, reportClick } from '@/api/help'
import { CATEGORY_TYPE, CONTACT_URL } from '@/utils/enum'
export default {
  components: { LeftFullNav, RightContent, SearchBox, [Pagination.name]: Pagination },
  name: 'Search',
  data() {
    return {
      page: 1,
      limit: 10,
      total: 0,
      currentCategory: {
        categoryId: '',
        name: ''
      },
      tabList: [],
      resultList: [],
      date,
      keyword: this.$route.query.keyword ? decodeURIComponent(this.$route.query.keyword) : '',
      downloadId: '',
      CATEGORY_TYPE,
      CONTACT_URL
    }
  },
  created() {
    this.$store.commit('SET_TITLE', '')
    this.handleSearch()
    this.handleGetIndexCategory()
  },
  methods: {
    handleGoToInnerPage(item) {
      reportClick({
        resourceId: item.id,
        type: CATEGORY_TYPE.ARTICLE
      })
      window.open(item.url, 'help')
    },
    handleGetSearchList() {
      let exactMatchArr = []
      if (this.currentCategory.categoryId) {
        exactMatchArr = [
          {
            name: 'categoryId',
            valueArr: [this.currentCategory.categoryId]
          }
        ]
      }
      if (!this.keyword) {
        return
      }
      getSearchList({
        exactMatchArr,
        searchKeyword: this.keyword,
        page: this.page - 1,
        limit: this.limit
      }).then(response => {
        this.total = response.data.content.total
        if (!this.currentCategory.categoryId) {
          const all = [
            {
              categoryId: '',
              categoryName: this.$t('help.all'),
              articleNumber: this.total
            }
          ]
          this.tabList = all.concat(response.data.content.articleCountList)
        }
        this.resultList = response.data.content.itemArr
      })
    },
    handleSearch() {
      this.page = 1
      this.handleGetSearchList()
    },
    handleSizeChange(num) {
      this.page = num
      this.handleGetSearchList()
    },
    handleTabCategory(item) {
      this.page = 1
      this.currentCategory = item
      this.handleGetSearchList()
    },
    handleGetIndexCategory() {
      getIndexCategory().then(response => {
        const content = response.data.content
        this.downloadId = content.downLoadId
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(hc-search) {
  padding: 0 360px;
  box-sizing: border-box;
  display: flex;
  @include e(search-box) {
    margin-top: 30px;
    padding-left: 28px;
    padding-right: 60px;
    box-sizing: border-box;
    width: 100%;
  }
  @include e(result-nav) {
    display: flex;
    flex-wrap: wrap;
    margin-left: 28px;
    margin-right: 28px;
    border-top: 1px #eeeeee solid;
    margin-top: 15px;
  }
  @include e(result-nav-item) {
    font-size: $--font-size-middle;
    color: $--color-grey-8;
    line-height: 21px;
    margin-top: 10px;
    margin-right: 20px;
    cursor: pointer;
    @include m(active) {
      color: $--color-primary;
    }
  }
  @include e(result-item) {
    padding: 24px 28px 0px 28px;
    &:hover {
      border-radius: 16px;
      background: #f8f8f8;
      .sky-hc-search__result-split {
        background: #f8f8f8;
      }
    }
  }
  @include e(result-tit) {
    font-size: $--font-size-big;
    font-weight: bold;
    color: $--color-grey-8;
    line-height: 26px;
    margin-top: 0px;
    margin-bottom: 14px;
  }
  @include e(result-con) {
    font-size: $--font-size-middle;
    color: $--color-grey-8;
    line-height: 21px;
    margin: 0px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    word-break: break-all;
    cursor: pointer;
    max-height: 63pxs;
  }
  @include e(result-time) {
    font-size: $--size-base;
    color: #999999;
    line-height: 19px;
    margin-top: 14px;
  }
  @include e(result-split) {
    width: 100%;
    height: 1px;
    background: #eeeeee;
    margin-top: 20px;
  }
  @include e(pagination) {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 24px;
    padding-bottom: 20px;
  }
  @include e(no-data) {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 84px;
  }
  @include e(no-data-img) {
    width: 212px;
    height: auto;
  }
  @include e(no-data-txt) {
    line-height: 26px;
    color: $--color-grey-8;
    font-weight: bold;
    font-size: $--font-size-big;
    margin-top: 24px;
  }
  @include e(resolve-tit) {
    color: $--color-grey-8;
    font-size: 16px;
    line-height: 21px;
    margin-top: 24px;
    margin-bottom: 10px;
  }
  @include e(resolve-txt) {
    color: $--color-grey-8;
    font-size: 16px;
    line-height: 24px;
  }
}
</style>
<style lang="scss">
.sky-hc-search__link {
  color: $--color-primary;
  &:hover,
  &:active,
  &:link,
  &:visited {
    color: $--color-primary;
  }
}
.sky-hc-search__result-item {
  & em {
    color: $--color-primary;
    font-style: normal;
  }
}
</style>
